// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3uyyE","title":"ClientInsurance_title__2K7ce","itemText":"ClientInsurance_itemText__2oxuA"};